import { http } from "App/http";
import { objectToFormData } from 'App/helpers';
import pick from 'lodash/pick';

export default {
    create(eventGroup) {
        return http.post(`/app/event-groups`, objectToFormData(eventGroup));
    },

    update(id, eventGroup) {
        let allowedKeys = [
            'address', 'city', 'zip', 'price', 'vat', 'vat_rate', 'spots',
            'hide_spots', 'is_closed', 'pay_before', 'online_payment_reserve',
            'product_danmark_id', 'send_reminder_email', 'send_reminder_sms',
            'payment_rates', 'payment_rates_interval', 'payment_rates_number',
            'name', 'notes', 'cal_id', 'image', 'thumbnail_url', 'practitioners',
            'color','waiting_list_enabled', 'fields', 'is_private', 'tags',
        ];
        if (eventGroup.practitioners && eventGroup.practitioners.length === 0) {
            eventGroup.practitioners = [null];
        }
        let formData = objectToFormData(pick(eventGroup, allowedKeys));
        // we have to spoof the method here due to Laravel not handling FormData properly on native PUT/PATCH requests.
        formData.append('_method', 'PUT');
        return http.post(`/app/event-groups/${id}`, formData);
    },

    delete(id) {
        return http.delete(`/app/event-groups/${id}`);
    },

    getSessions(id) {
        return http.get(`/app/event-groups/${id}/events`);
    },

    updateSessions(id, sessions, sharedAttributes) {
        return http.post(`/app/event-groups/${id}/events`, {
            events: sessions,
            shared_attributes: sharedAttributes
        });
    }
}
